import React from 'react';
import ReactDOM from 'react-dom/client';
import './vistas/css/index.css';
import App from './App';
import Footer from './vistas/plantillas/footer';
import Header from './vistas/plantillas/header';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './contexto/AuthContext';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <Header/>
      <App />
      <Footer/>
    </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
